module.exports = __webpack_public_path__ + "media/veracruz/ConvocatoriaTorneoFutbol-631351b9.png";